import { useMutation } from "@tanstack/react-query";
import { apiV1Endpoint } from "../../../../../../../api/v1";
import { ApiResponse } from "../../../../../../../types/api-response";
import axios from "../../../../../../../utils/axiosInceptor";

type EarlyTerminationStatus = "approved" | "rejected";

type Payload = {
  leaseId: string;
  status: EarlyTerminationStatus;
};

const updateEarlyTerminationDecision = async (data: Payload) => {
  const url = `${apiV1Endpoint}/booking/updateEarlyTerminationDecision`;
  const response = await axios.post<ApiResponse>(url, data);
  return response.data.result;
};

type UseUpdateEarlyTerminationDecisionOptions = {
  onSuccess?: () => void;
  onError?: () => void;
};

export const useUpdateEarlyTerminationDecision = (options: UseUpdateEarlyTerminationDecisionOptions = {}) => {
  const { onSuccess, onError } = options;

  const { mutate, isSuccess } = useMutation({
    mutationFn: updateEarlyTerminationDecision,
    onSuccess,
    onError,
  });

  return { updateEarlyTerminationDecision: mutate, isSuccess };
};
